export const GET_PAYMENTS = Symbol('GET_PAYMENTS');
export const GET_PAYMENTS_REQUEST = Symbol('GET_PAYMENTS_REQUEST');
export const GET_PAYMENTS_SUCCESS = Symbol('GET_PAYMENTS_SUCCESS');
export const GET_PAYMENTS_ERROR = Symbol('GET_PAYMENTS_ERROR');

